import {FC} from "react"

import LoaderSpinner from "public/images/meduza-loader.svg"

const Loader: FC = () => (
  <div className="w-full h-full min-h-tablet-frame flex items-center justify-center">
    <div className="w-24">
      <LoaderSpinner />
    </div>
  </div>
)

export default Loader
